// App.tsx
import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Box } from '@mui/material';

import './App.css';
import Home from './pages/Home';
import Exercises from './pages/Exercises';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WorkoutsPage from './pages/WorkoutsPage';
import { Exercise } from './utils/types';
import LoggedExercises from './pages/LoggedExercises';

const App: React.FC = () => {
  // exercises állapot létrehozása az elérhető gyakorlatok tárolásához
  const [exercises, setExercises] = useState<Exercise[]>([]);

  // bodyPart állapot a gyakorlatok szűrésére a test adott részére
  const [bodyPart, setBodyPart] = useState<string>('all');

  return (
    <Box className="app-container" sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar /> {/* Navigációs sáv, ami az oldal tetején marad */}
      
      <Box component="main" sx={{ flex: '1' }}>
        <Routes> {/* Az oldal különböző útvonalainak meghatározása */}
          <Route path="/" element={<Home />} /> {/* Főoldal */}
          <Route path="/exercises" element={<Exercises />} /> {/* Gyakorlatok oldal */}
          
          <Route 
            path="/workouts"
            element={
              <WorkoutsPage
                exercises={exercises} // exercises állapot továbbítása
                setExercises={setExercises} // exercises állapot módosító függvény továbbítása
                bodyPart={bodyPart} // bodyPart szűrési állapot továbbítása
                setBodyPart={setBodyPart} // bodyPart szűrés módosító függvény továbbítása
              /> // Keresés a gyakorlatok között oldal
            }
          />
          <Route path="/logged-exercises" element={<LoggedExercises />} /> {/* Gyakorlatok naplózott oldal */}
        </Routes>
      </Box>
      
      <Footer /> {/* Fixált lábléc, az oldal alján jelenik meg */}
    </Box>
  );
};



export default App;
